import { render, staticRenderFns } from "./_subAccountAdd.vue?vue&type=template&id=9928345a&lang=pug"
import script from "./_subAccountAdd.vue?vue&type=script&lang=js"
export * from "./_subAccountAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports